{
  "name": "bp-web-components",
  "version": "0.27.2",
  "description": "Web components for The Bible Project Classroom visuals ",
  "license": "UNLICENSED",
  "type": "module",
  "main": "index.js",
  "repository": {
    "type": "git",
    "url": "https://github.com/thebibleproject/bp-web-components"
  },
  "engines": {
    "node": ">=24"
  },
  "scripts": {
    "build": "vite build",
    "dev:serve": "npx serve dist -p 4000 --cors",
    "dev:watch": "vite build --watch",
    "dev": "run-p dev:*",
    "format": "prettier --write .",
    "lint:js": "eslint --cache --cache-location ./node_modules/.cache/eslint .",
    "lint:css": "stylelint --cache --cache-location ./node_modules/.cache/stylelint \"src/**/*.css\"",
    "lint": "run-p lint:*",
    "prepare": "husky",
    "storybook": "storybook dev -p 6006 --no-open",
    "storybook:build": "storybook build",
    "test": "vitest",
    "test:coverage": "vitest run --coverage",
    "typecheck": "tsc -b",
    "version": "npx tsx scripts/version.ts"
  },
  "dependencies": {
    "@lit-labs/observers": "^2.0.5",
    "classnames": "^2.3.2",
    "focus-trap": "^8.0.0",
    "hls.js": "^1.6.5",
    "idb": "^8.0.3",
    "lit": "^3.0.0"
  },
  "devDependencies": {
    "@csstools/postcss-global-data": "^4.0.0",
    "@eslint/js": "^9.0.0",
    "@storybook/web-components-vite": "^10.3.0",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@testing-library/jest-dom": "^6.0.0",
    "@types/node": "^25.5.0",
    "@vitest/coverage-v8": "^4.1.0",
    "chromatic": "^15.3.0",
    "eslint": "^9.39.4",
    "eslint-plugin-import": "^2.28.0",
    "fake-indexeddb": "^6.2.5",
    "husky": "^9.1.7",
    "jsdom": "^29.0.0",
    "lint-staged": "^16.4.0",
    "msw": "^2.12.13",
    "msw-storybook-addon": "^2.0.5",
    "npm-run-all": "^4.1.5",
    "postcss": "^8.5.8",
    "postcss-load-config": "^6.0.1",
    "postcss-preset-env": "^11.2.0",
    "prettier": "^3.5.3",
    "react": "^19.0.0",
    "react-dom": "^19.0.0",
    "storybook": "^10.3.0",
    "stylelint": "^17.4.0",
    "stylelint-config-recommended": "^18.0.0",
    "typescript": "^5.8.3",
    "typescript-eslint": "^8.57.1",
    "vite": "^8.0.1",
    "vitest": "^4.1.0"
  },
  "msw": {
    "workerDirectory": ".storybook/public"
  }
}
